module.exports = __webpack_public_path__ + "static/media/arrow-right.27d9db60.svg";